import type { GQL_ID } from '@@partner:types:graphql'
import type { BrandInfo } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

export interface BrandInfoInput {
  name: string
  slug: string
  logo_id?: GQL_ID
  square_logo_id?: GQL_ID
  default_shop_id?: GQL_ID
  primaryColorHex?: string
  primaryTextColorHex?: string
  appStyleConfig?: string
}

export interface UpdateCurrentBrandInfo {
  brandInfo: BrandInfo
}

export interface UpdateCurrentBrandInfoVariables {
  brandInfo: BrandInfoInput
}

export const GQL_MUTATION_UPDATE_CURRENT_BRAND_INFO = gql`
  mutation ($brandInfo: BrandInfoInput!) {
    brandInfo: updateCurrentBrandInfo(brandInfo: $brandInfo) {
      id
      name
      logo_id
      logo {
        url
      }
      square_logo_id
      squareLogo {
        url
      }
      defaultShop {
        id
        name
        address
      }
      primaryColorHex
      primaryTextColorHex
      appStyleConfig
    }
  }
`

export const useUpdateCurrentBrandInfo = () => {
  return useMutation<UpdateCurrentBrandInfo, UpdateCurrentBrandInfoVariables>(
    GQL_MUTATION_UPDATE_CURRENT_BRAND_INFO
  )
}
